import React, { useEffect, useState } from "react";
import { Tabs, Button, Avatar, Card, Input, Modal } from "antd";
import Main from "../../components/layout/Main";
import ArrowImage from "../../assets/images/arrow-up-for-message.svg";
import TrofiesImage from "../../assets/images/trofies-image.svg";
import PlayerImage from "../../assets/images/leaderboard-profile.jpg";
import { useTournament } from "../../context/TournamentContext";
import { useParams, useLocation } from "react-router";
import { useNavigate } from "react-router";
import { Check } from "lucide-react";
import { Severty, ShowToast } from "../../helper/toast";
import { getDiff, isValidUrl } from "../../helper/functions";
import { useChat } from "../../context/ChatContext";
import moment from "moment";
import { Typography } from "antd";
const { Text } = Typography;

const LobbyTournament = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tournament, setTournament] = useState({});
  const [loading, setLoading] = useState();
  const {
    loadTournamentList,
    joinTeam,
    joinWithTeam,
    loadTournament,
    updateStreamLink,
  } = useTournament();
  const { id } = useParams();
  const location = useLocation();
  const inviteeUserIdsFromState = location.state?.inviteeUserIds || [];
  const streamData = location.state?.streamingPayload;
  const [teams, setTeams] = useState([]);
  const [data, setData] = useState([]);
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [messageText, setMessageText] = useState("");

  // --------- Chat Context ----------
  const {
    chatMessages,
    listenToMessages,
    stopListeningToMessages,
    listenToTournamentChat,
    sendTournamentMessage,
  } = useChat();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const Navigate = useNavigate();

  // --------- Handlers -----------
  const fetchTournamentList = async (id) => {
    try {
      const tournamentResponse = await loadTournament(id);
      if (tournamentResponse.data.status === 200) {
        const data = tournamentResponse.data.data.tournament;
        setTournament(data);
      }

      const response = await loadTournamentList({ tournamentId: id });
      if (response.status === 200) {
        setTeams(response.data.data.teams);
        setData(response.data.data);
      }
    } catch (error) {
      console.log("Error occured when get tournament list", error);
    }
  };

  const handleCreateNewTeam = async (tournamentId, teamId) => {
    try {
      let payload = { tournamentId, teamId };

      // If invitees were passed from the tournament details "Join with Team" flow,
      // enforce that the total players (invitees + current user) match totalPlayerSize
      // and send inviteeUserId array to the API.
      if (inviteeUserIdsFromState && inviteeUserIdsFromState.length > 0) {
        const requiredPlayers = Number(tournament.totalPlayerSize) || 1;
        const totalPlayers = inviteeUserIdsFromState.length + 1;
        const canSoloJoin =
          tournament.allowSolo === undefined || tournament.allowSolo;
        if (
          !canSoloJoin &&
          requiredPlayers > 1 &&
          totalPlayers !== requiredPlayers
        ) {
          ShowToast(
            `Team size mismatch. You need exactly ${
              requiredPlayers - 1
            } invited friends to join this tournament.`,
            Severty.ERROR,
          );
          return;
        }

        payload = {
          ...payload,
          inviteeUserId: inviteeUserIdsFromState,
        };
      }

      let response;
      if (inviteeUserIdsFromState.length + 1 === 1) {
        response = await joinTeam(payload);
      } else {
        response = await joinWithTeam(payload);
      }
      if (response.status === 200 || response.status === 201) {
        if (streamData?.players?.length > 0) {
          await updateStreamLink(streamData);
        }
        ShowToast(response.message, Severty.SUCCESS);
        fetchTournamentList(id);
        Navigate(`/lobby-tournaments/${tournamentId}`);
      }
    } catch (error) {
      ShowToast(error.message, Severty.ERROR);
      console.log("Error occured when create team", error);
    }
  };

  // ---- Tournament Chat ----
  const handleSend = async () => {
    if (!messageText.trim()) return;
    await sendTournamentMessage(id, messageText);
    setMessageText("");
  };

  // ---------- use effects -----------
  useEffect(() => {
    fetchTournamentList(id);
    listenToTournamentChat(id, setLoading);
  }, [id]);

  return (
    <Main>
      <div className="section-main">
        <div className="section-headding">
          <div className="lobby-card-header">
            <h6>{tournament?.name_en}</h6>
            <div className="card-top-info">
              <div className="tunament-date">
                {moment(tournament.startDate).format("DD MMM YYYY | HH:mm A")}
              </div>
              <div className="starts-time">
                Starts in:{" "}
                <span>{getDiff(tournament.startDate, moment())}</span>
              </div>
            </div>

            <div className="card-tags">
              <img src={TrofiesImage} alt="Trophies" />
              {tournament &&
                tournament?.trophyStructure?.map((trophy, index) => (
                  <span key={index}>{trophy}</span>
                ))}
            </div>
            <div className="tunament-slot">{`${
              tournament.totalRegisteredPlayers
            }/ ${
              tournament?.teamSize *
              (tournament.totalPlayerSize > 0 ? tournament.totalPlayerSize : 1)
            } slots`}</div>
            {/* <div>
              <Button
                className="create-team-button"
                onClick={() => handleCreateNewTeam(id)}
              >
                Create New Team
              </Button>
            </div> */}
          </div>
          <div className="create-btn-header">
            {/* <Button
              className="private-tunament-button Fill-button"
              onClick={showModal}
              // onClick={() => navigate("/create-tournaments")}
            >
              Add Stream Link
            </Button> */}
            <Button
              className="private-tunament-button Fill-button"
              onClick={() =>
                Navigate(`/upcoming-tournaments/tournaments-details/${id}`)
              }
            >
              View Brackets
            </Button>
            <div className="stream-info-box">
              <div>
                <Text strong style={{ color: "white" }}>
                  RTMP URL :{" "}
                </Text>
                <Text
                  style={{ color: "white" }}
                  copyable={{ text: data?.RTMP_URL }}
                >
                  {data?.RTMP_URL}
                </Text>
              </div>

              <div style={{ color: "white" }}>
                <Text strong style={{ color: "white" }}>
                  Stream Key :{" "}
                </Text>
                <Text
                  style={{ color: "white" }}
                  copyable={{ text: data?.streamKey }}
                >
                  {data?.streamKey}
                </Text>
              </div>
            </div>
          </div>
        </div>
        <div className="lobby-main-outer">
          <div className="lobby-card-outer">
            {teams?.map((team, index) => (
              <div
                className="lobby-team-card"
                key={index}
                onClick={() => handleCreateNewTeam(id, team?.id)}
              >
                <h6>{team?.teamName}</h6>
                <ul>
                  {team?.members?.map((member, index) => (
                    <li>
                      <div class="team-player-image" key={index}>
                        <img
                          src={
                            isValidUrl(member?.profilePic)
                              ? member?.profilePic
                              : PlayerImage
                          }
                        />
                        <h5>{member?.name}</h5>
                      </div>
                      <div className="check-right-player">
                        <Check />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="lobby-chat-outer">
            <Card className="for-chat-cards for-chat-cards-for-chat">
              <div className="card-header-new">Chat</div>
              <div className="chat-body">
                {chatMessages.map((msg, idx) => {
                  const isRight =
                    msg.senderId == userProfile?._id ? true : false;
                  return (
                    <div
                      key={idx}
                      className={`chat-message ${
                        isRight ? "sent-message" : "received-message"
                      }`}
                    >
                      {!isRight && (
                        <Avatar
                          src={msg.senderImage || PlayerImage}
                          size="large"
                          className="chat-avatar-left"
                        />
                      )}

                      <div className="chat-bubble">
                        <div className="chat-meta">
                          <span className="chat-name">{msg.senderName}</span>
                          <span className="chat-time">
                            {moment(msg.timestamp).format("HH:mm A")}
                          </span>
                        </div>
                        <div className="chat-content">{msg.message}</div>
                      </div>

                      {isRight && (
                        <Avatar
                          src={PlayerImage}
                          size="large"
                          className="chat-avatar-right"
                        />
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="for-message-send">
                <Input
                  placeholder="Write comment"
                  value={messageText}
                  onChange={(e) => setMessageText(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSend()}
                />
                <Button className="Fill-button send-button">
                  <img src={ArrowImage} onClick={() => handleSend()} />
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </div>
      <Modal
        width={384}
        title="Add Stream Link"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        centered
        onOk={handleOk}
        onCancel={handleCancel}
        className="custom-modal"
        footer={false}
      >
        <div className="add-stream-modal">
          <Input className="input-full" placeholder="Paste link here" />
          <Button className="Fill-button">Add</Button>
        </div>
      </Modal>
    </Main>
  );
};

export default LobbyTournament;
